import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import { useParams } from "react-router-dom";
import { Campaign } from "../models";
import { CampaignDetailsPresenter } from "./CampaignDetailsPresenter";
import { useState } from "react";
import { INITIAL_CAMPAIGN } from "../constant";
import { PATHS } from "src/routes";
import { useCampaignDetailsAPI, useCampaignSendAPI, useCampaignUpdateAPI } from "../campaigns.api";
import { useTwilioConfigAPI } from "../../settings/settings.api";

export default function CampaignDetailsContainer() {
  const { id: routeId } = useParams();
  const [id, setId] = useState(routeId);
  const [isRefreshing, setIsRefreshing] = useState(id !== "new");
  const {
    data: campaignDetails,
    isLoading: isCampaignDetailsLoading,
    refetch: refetchCampaignDetails
  } = useCampaignDetailsAPI(id, () => setIsRefreshing(false));
  const { data: twilioConfig } = useTwilioConfigAPI();

  const refreshCampaignDetails = () => {
    if (id === "new") return;
    setIsRefreshing(true);
    refetchCampaignDetails();
  };

  const sendCampaignMutation = useCampaignSendAPI(refreshCampaignDetails);
  const sendCampaign = () => {
    if (id) {
      sendCampaignMutation.mutate(id);
    }
  };

  const updateMutation = useCampaignUpdateAPI((updatedCampaign: Campaign) => {
    if (updatedCampaign?.id) {
      if (id === "new") {
        window.history.replaceState(null, '', `${PATHS.CAMPAIGN_LIST}/${updatedCampaign.id}`);
        setId(updatedCampaign.id);
      }
    }
    refreshCampaignDetails();
  });
  const updateCampaign = (campaign: Campaign) => {
    updateMutation.mutate(campaign);
  };

  const newCampaignPattern = {
    ...INITIAL_CAMPAIGN,
    name: `${INITIAL_CAMPAIGN.name} ${new Date().toLocaleDateString()}`,
  };
  const campaign = campaignDetails || newCampaignPattern;

  return (
    <SpinnerWrapper loading={isCampaignDetailsLoading && id === routeId}>
      {campaign && (
        <CampaignDetailsPresenter
          campaign={campaign}
          config={twilioConfig}
          loading={isRefreshing || updateMutation.isLoading || sendCampaignMutation.isLoading}
          updateCampaign={updateCampaign}
          onSend={sendCampaign}
        />
      )}
    </SpinnerWrapper>
  );
}